import axios from 'axios/index';
import {defaultBehaviour} from "../utils/ServiceUtils";
import {cleanUpSurveyBeforeSave} from "../utils/SurveyCleanupUtils";

function getSurveysList(userId, okCallback, koCallback) {
    return defaultBehaviour(axios.get(`/quests/all/${userId}`), okCallback, koCallback);
}

function getRespondentsCountByTypeForAllSurveysOfUser(type, userId, okCallback, koCallback) {
    return defaultBehaviour(axios.get(`/quests/all/answers/count/${type}/${userId}`), okCallback, koCallback);
}

function getOrCreateConversationForSurveyId(surveyId, countryStringId, okCallback, koCallback) {
    return axios.post('/quests/conversation', null, {
        params: {
            "questId": surveyId,
            "countryStringId": countryStringId,
        }
    }).then((response) => {
        okCallback && okCallback(response);
    })
    .catch((error) => {
        koCallback && koCallback(error.response);
    });
}

function getConversationWithMessagesListForConversationId(conversationId, okCallback, koCallback) {
    return axios.get('/openai/getConvWithMessages/' + conversationId)
        .then((response) => {
            okCallback && okCallback(response);
        })
        .catch((error) => {
            koCallback && koCallback(error.response);
        });
}

function getSurveyById(surveyId, okCallback, koCallback) {
    return axios.get('/quests/' + surveyId)
        .then((response) => {
            // THIS IS A HACK
            if (response && response.data && response.data.type) {
                response.data.type = "test"
            }

            if (response && response.data && response.data.active) {
                response.data.active = false
            }

            console.log("Hack response: ", response)

            okCallback && okCallback(response);
        })
        .catch((error) => {
            koCallback && koCallback(error.response);
        });
}

function getSurveyTemplateById(surveyId, okCallback, koCallback){
    return axios.get('/quests/template/' + surveyId)
        .then((response) => {
            okCallback && okCallback(response);
        })
        .catch((error) => {
            koCallback && koCallback(error.response);
        });
}

function saveSurvey(surveyData, okCallback, koCallback) {
    let surveyId = surveyData.id ? surveyData.id : "new_quest";
    let cleanedSurvey = cleanUpSurveyBeforeSave(surveyData);
    return axios.post('/quests/' + surveyId, cleanedSurvey)
        .then((response) => {
            okCallback && okCallback(response);
        })
        .catch((error) => {
            koCallback && koCallback(error.response);
        });
}

function cloneSurvey(surveyId, okCallback, koCallback) {
    defaultBehaviour(
        axios.get('/quests/clone/' + surveyId), okCallback, koCallback);
}

function postSurveyTitle(surveyId, surveyTitle, okCallback, koCallback) {
    const payload = {
        survey_id: surveyId,
        survey_title: surveyTitle
    };

    return axios.post('/quests/title', payload)
        .then((response) => {
            okCallback && okCallback(response);
        })
        .catch((error) => {
            koCallback && koCallback(error.response);
        });
}

function getGeneralStats(surveyId,okCallback, koCallback){
    return axios.get('/quests/generalStats/' + surveyId)
        .then((response) => {
            okCallback && okCallback(response);
        })
        .catch((error) => {
            koCallback && koCallback(error.response);
        });
}

function GetSurveyCsv(qid, ageGroups, okCallback, koCallback) {
    return axios.post("/quests/answers/" + qid, ageGroups, {headers: {
        'Content-Type': 'application/json'
    }})
        .then((response) => {
            okCallback && okCallback(response);
        })
        .catch((error) => {
            koCallback && koCallback(error.response);
        });
};

function ChangeSurveyStatus(surveyId, surveyStatus, okCallback, koCallback) {
    return axios.post('/quests/status/'+surveyId, surveyStatus,{headers: {
            'Content-Type': 'text/plain'
        }})
        .then((response) => {
            okCallback && okCallback(response);
        })
        .catch((error) => {
            koCallback && koCallback(error.response);
        });
}

function HelpSearch(searchText, okCallback, koCallback) {
    return axios.post('/help/search', searchText,{headers: {
            'Content-Type': 'text/plain'
        }})
        .then((response) => {
            okCallback && okCallback(response);
        })
        .catch((error) => {
            koCallback && koCallback(error.response);
        });
}

function getSurveyNameAndStatus(surveyId,okCallback,koCallback){
    return axios.get('quests/nameAndStatus/'+surveyId)
        .then((response) => {
            okCallback && okCallback(response);
        })
        .catch((error) => {
            koCallback && koCallback(error.response);
        });
}

function exportPpt(chartsPayload, okCallback, koCallback) {
    return axios.post('quests/chartsPpt/', chartsPayload, {responseType: 'arraybuffer'})
        .then(function successCallback(response) {
            okCallback && okCallback(response);
        }, function errorCallback(error) {
            koCallback && koCallback(error.response);
        });
}

function deleteSurveyById(surveyId,okCallback,koCallback){
    return axios.delete('quests/' + surveyId)
        .then((response) => {
            okCallback && okCallback(response);
        })
        .catch((error) => {
            koCallback && koCallback(error.response);
        });
}

function deleteAnswersForSurvey(surveyId, okCallback, koCallback) {
    return defaultBehaviour(axios.delete(`/quests/answers/${surveyId}`), okCallback, koCallback);
}

function getTemplates(search = '', okCallback, koCallback) {
    return defaultBehaviour(
        axios.get('/quests/templatesSearch', {params: {templatesSearch: search}}), okCallback, koCallback);
}

export default {
    getSurveysList,
    getRespondentsCountByTypeForAllSurveysOfUser,
    getSurveyById,
    getSurveyTemplateById,
    saveSurvey,
    cloneSurvey,
    postSurveyTitle,
    getGeneralStats,
    GetSurveyCsv,
	ChangeSurveyStatus,
	HelpSearch,
    getSurveyNameAndStatus,
    deleteSurveyById,
    deleteAnswersForSurvey,
    getTemplates,
    exportPpt,
    getOrCreateConversationForSurveyId,
    getConversationWithMessagesListForConversationId
} ;